<template>
  <catalog-page
    :send-gtm-data="true"
    :title="taxon.name"
    :banner="taxon.banner_url"
    :taxon="taxon"
    :case-scope="false"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import isPresent from '~/utils/isPresent'
import appendUrlParam from '~/utils/appendUrlParam'
import CatalogPage from '~/components/catalog/CatalogPage.vue'

export default {
  components: { CatalogPage },
  async asyncData({
    $axios,
    route,
    store,
    error,
    $sentry,
    $isBrStore,
    ...ctx
  }) {
    try {
      const taxonSlug = route.params.pathMatch
      const taxonParam = { taxon: taxonSlug }
      const storeInfo = store.getters.storeInfo

      const params = {
        ...storeInfo,
        ...taxonParam,
      }

      const { taxon } = await $axios.$get(
        appendUrlParam(`/taxons/${taxonSlug}`, params),
        {
          cache: {
            ignoreCache: false,
          },
        }
      )

      return {
        taxon,
        taxonSlug,
      }
    } catch (err) {
      error({
        statusCode: 404,
        message: 'Taxon not found',
      })
    }
  },
  data() {
    return { taxon: { name: '' } }
  },
  computed: {
    ...mapGetters(['storeInfo']),
  },
  methods: {
    isPresent,
  },
  head() {
    return {
      title: this.taxon.name,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${this.taxon.meta_description}`,
        },
      ],
    }
  },
}
</script>
